import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import { logout } from "../../../redux/actions/authActions";
import mayanot_logo from "../../../assets/images/mayanot_logo.jpg";
import yamim_logo from "../../../assets/images/yamim_logo.png";
import shefaram_logo from "../../../assets/images/shefaram_logo.png";
import miahcom_logo from "../../../assets/images/miahcom_logo.png";
import migdal_logo from "../../../assets/images/migdal_logo.png";
import elad_logo from "../../../assets/images/elad_logo.png";
import katsrin_logo from "../../../assets/images/katsrin_logo.png";
import ata_logo from "../../../assets/images/ata_logo.png";
import yuvallim_logo from "../../../assets/images/yuvallim_logo.png";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";
import { fetchSiteConfig } from "../../../redux/actions/dataActions";
import { API_URL } from "../../../redux/actions/api";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);

  const logoutFunc = () => {
    dispatch(logout());
    window.location.replace("/");
  };

  let hostname = window.location.hostname;
  if (hostname.startsWith("www.")) {
    hostname = hostname.substring(4);
  }

  const logoMap = {
    "mayanot-hasharon.anstc.com": {
      logo: mayanot_logo,
      logo_height: "50px",
      logo_margin_top: "0px",
    },
    "yamim.anstc.com": {
      logo: yamim_logo,
      logo_height: "360px",
      logo_margin_top: "35px",
    },
    "shefaram.anstc.com": {
      logo: shefaram_logo,
      logo_height: "90px",
      logo_margin_top: "35px",
    },
    "miahcom.anstc.com": {
      logo: miahcom_logo,
      logo_height: "90px",
      logo_margin_top: "35px",
    },
    "migdal-haemeq.anstc.com": {
      logo: migdal_logo,
      logo_height: "90px",
      logo_margin_top: "35px",
    },
    "elad.anstc.com": {
      logo: elad_logo,
      logo_height: "90px",
      logo_margin_top: "30px",
    },
    "yuvallim.anstc.com": {
      logo: yuvallim_logo,
      logo_height: "90px",
      logo_margin_top: "30px",
    },
    "katsrin.anstc.com": {
      logo: katsrin_logo,
      logo_height: "90px",
      logo_margin_top: "30px",
    },
    "mayanotata.anstc.com": {
      logo: ata_logo,
      logo_height: "90px",
      logo_margin_top: "30px",
    },
  };

  const mapped = logoMap[hostname];
  const crossDomainLogoHostMap = {
    "mayanot-hasharon.anstc.com": "https://mayanot-hasharon-admin.anstc.com",
    "ans.mipo.co.il": "https://appointments-ans.mipo.co.il",
  };

  const resolveRelativeLogoUrl = (value) => {
    if (typeof value !== "string" || /^https?:\/\//i.test(value)) {
      return value;
    }

    const crossHost = crossDomainLogoHostMap[hostname];
    if (crossHost) {
      return `${crossHost}/${value.replace(/^\/+/, "")}`;
    }

    // General case: build absolute URL from API origin
    const apiOrigin = new URL(API_URL).origin;
    return `${apiOrigin}/${value.replace(/^\/+/, "")}`;
  };

  const [cfgLogo, setCfgLogo] = useState(null);
  const [cfgHeight, setCfgHeight] = useState(null);
  const [cfgMarginTop, setCfgMarginTop] = useState(null);

  const normalizePx = (val) => {
    if (!val) return val;
    val = String(val).trim();
    return /^\d+$/.test(val) ? val + "px" : val;
  };

  useEffect(() => {
    fetchSiteConfig()(dispatch).then((config) => {
      if (config.site_logo) {
        setCfgLogo(resolveRelativeLogoUrl(config.site_logo));
      }
      if (config.logo_height) setCfgHeight(normalizePx(config.logo_height));
      if (config.logo_margin_top) setCfgMarginTop(normalizePx(config.logo_margin_top));
    });
  }, [dispatch, hostname]);

  const useSiteSettingsLogo = Boolean(cfgLogo);
  const logo = useSiteSettingsLogo ? cfgLogo : mapped?.logo ?? null;
  const logo_height = useSiteSettingsLogo
    ? cfgHeight ?? mapped?.logo_height ?? "90px"
    : mapped?.logo_height ?? "90px";
  const logo_margin_top = useSiteSettingsLogo
    ? cfgMarginTop ?? mapped?.logo_margin_top ?? "30px"
    : mapped?.logo_margin_top ?? "30px";

  return (
    <section className="header is-sticky">
      {logo ? (
        <img
          src={logo}
          style={{ height: logo_height, marginTop: logo_margin_top }}
          alt="logo"
          className="logo"
          onClick={() => navigate("/")}
        />
      ) : (
        <div
          style={{ height: logo_height, marginTop: logo_margin_top }}
          className="logo"
        />
      )}

      {isAuthenticated ? null : null}

      <div className="side-header">
        <div className="side-header-items">
          {isAuthenticated && (
            <IconButton
              onClick={logoutFunc}
              color="inherit"
              aria-label="התנתקות"
              size="small"
            >
              <LogoutIcon className="logout-btn" fontSize="small" />
            </IconButton>
          )}
        </div>
      </div>
    </section>
  );
};

export default Header;
